import { Switcher } from "./switcher";
import { ICommonUtilInterface } from "../common/common-util.interface";
import { SwitcherItem } from "./switcher-item";
import { BroadcastPresetAudioChannel } from "./broadcast-preset-audio-channel";
import { ESwitcherAssetType } from "./switcher-item.type.enum";

export class BroadcastPreset {
  constructor(
    public id: string,
    public name: string,
    public thumbnailUrl: string,
    public switchers: Switcher[],
    public audioChannels: BroadcastPresetAudioChannel[],
  ) {}

  public static createNew(
    name: string,
    commonUtils: ICommonUtilInterface,
  ): BroadcastPreset {
    const switcherItems = [];
    for (let i = 0; i < 12; i++) {
      switcherItems.push(
        SwitcherItem.createEmptyItem(commonUtils.generateGuid(), i),
      );
    }
    const id = commonUtils.generateGuid();
    const switcher = new Switcher("switcher 1", switcherItems);
    const audioChannels = [
      BroadcastPresetAudioChannel.createNew(
        ESwitcherAssetType.Empty,
        "Master",
        id,
        "XX",
        0,
        1.0,
        true,
      ),
    ];
    return new BroadcastPreset(id, name, "", [switcher], audioChannels);
  }

  public get hasPreviewSelected(): boolean {
    return !!this.switchers
      .flatMap((panel) => panel.items)
      .find((item) => item.isPreview);
  }

  public get hasProgramSelected(): boolean {
    return !!this.switchers
      .flatMap((panel) => panel.items)
      .find((item) => item.isProgram);
  }
  public clone(id: string): BroadcastPreset {
    return new BroadcastPreset(
      id,
      "Duplicated From " + this.name,
      "",
      this.switchers.map((s) => s.clone()),
      this.audioChannels.map((ac) => ac.clone()),
    );
  }
}
